import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 2,
  class: "tw-text-[24px]"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 3,
  class: "tw-px-4 tw-text-center"
}
const _hoisted_6 = {
  ref: "svgtag",
  style: {"max-height":"40vh"},
  class: "tw-mx-auto"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LatexView = _resolveComponent("LatexView")!

  return (_ctx.questionKind == 'latex')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LatexView, { latex: _ctx.question }, null, 8, ["latex"])
      ]))
    : (_ctx.questionKind == 'html')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          innerHTML: _ctx.question
        }, null, 8, _hoisted_2))
      : (_ctx.questionKind == 'mathml')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("math", { innerHTML: _ctx.question }, null, 8, _hoisted_4)
          ]))
        : (_ctx.questionKind == 'svg')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                _createElementVNode("g", { innerHTML: _ctx.question }, null, 8, _hoisted_7)
              ], 512))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.question), 1))
}